/* Onewheelers scrollytelling engine
 * Tracks scroll progress of tall "scrolly" sections and exposes it as a CSS
 * custom property (--ow-p, 0 → 1) on the section element. All motion is done
 * in CSS from that variable, so the JS stays tiny and cheap (one rAF loop,
 * only while a tracked section is on screen).
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var tracked = []; // { el, active }
  var rafId = null;

  function computeProgress(el) {
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight;
    var scrollable = rect.height - vh;
    if (scrollable <= 0) return 0;
    var p = -rect.top / scrollable;
    return Math.min(1, Math.max(0, p));
  }

  function tick() {
    rafId = null;
    var anyActive = false;
    for (var i = 0; i < tracked.length; i++) {
      var t = tracked[i];
      if (!t.active) continue;
      anyActive = true;
      var p = computeProgress(t.el);
      if (p !== t.last) {
        t.last = p;
        t.el.style.setProperty('--ow-p', p.toFixed(4));
        /* scroll-scrub: video volgt de scrollpositie frame-exact */
        if (t.video && t.video.duration) {
          var target = p * (t.video.duration - 0.05);
          if (Math.abs(t.video.currentTime - target) > 0.02) {
            t.video.currentTime = target;
          }
        }
      }
    }
    if (anyActive) rafId = window.requestAnimationFrame(tick);
  }

  function wake() {
    if (rafId === null) rafId = window.requestAnimationFrame(tick);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      for (var i = 0; i < tracked.length; i++) {
        if (tracked[i].el === entry.target) tracked[i].active = entry.isIntersecting;
      }
    });
    wake();
  });

  function initScrolly(root) {
    if (reducedMotion.matches) return;
    root.querySelectorAll('[data-ow-scrolly]').forEach(function (el) {
      if (el.dataset.owInit) return;
      el.dataset.owInit = '1';
      var video = el.querySelector('video[data-ow-scrub]');
      var t = { el: el, active: false, last: -1, video: video };
      if (video) {
        video.muted = true;
        video.load();
        video.addEventListener('loadedmetadata', function () {
          t.last = -1; /* forceer her-toepassen van progress zodra duration bekend is */
          wake();
        });
      }
      tracked.push(t);
      io.observe(el);
    });
  }

  /* Step-based sections (ow-scrolly-story): the visual that is "active"
   * follows the step that currently crosses the middle of the viewport. */
  function initSteps(root) {
    root.querySelectorAll('[data-ow-steps]').forEach(function (section) {
      if (section.dataset.owStepsInit) return;
      section.dataset.owStepsInit = '1';

      var steps = section.querySelectorAll('[data-ow-step]');
      var visuals = section.querySelectorAll('[data-ow-visual]');
      if (!steps.length) return;

      function activate(index) {
        steps.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
        visuals.forEach(function (v, i) { v.classList.toggle('is-active', i === index); });
      }
      activate(0);

      var stepIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var idx = Array.prototype.indexOf.call(steps, entry.target);
          if (idx > -1) activate(idx);
        });
      }, { rootMargin: '-45% 0px -45% 0px' });

      steps.forEach(function (s) { stepIo.observe(s); });
    });
  }

  function initAll(root) {
    initScrolly(root);
    initSteps(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  window.addEventListener('scroll', wake, { passive: true });
  window.addEventListener('resize', wake);

  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
